<header
  class="fls-0-0 vh-2 vw-p100 fld-row flg-4 ai-ctr pwl-5 pwr-4 mat-elevation-z0"
  style="z-index: 10;"
>
  <h3 class="fls-1-1 mwa-0"><ng-content></ng-content></h3>

  <button
    (click)="close()"
    mat-icon-button
    aria-label="Close Modal"
    (keyup.enter)="close()"
    (keydown.enter)="$event.preventDefault()"
  >
    <mat-icon>cancel</mat-icon>
  </button>
</header>
